import Vue from 'vue';
import * as C from '../constants';

export default {
  // region Countries
  [C.TWENTY_COUNTRIES_LOAD_PENDING](state) {
    Vue.set(state, 'countries', {
      ...state.countries,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
    });
  },

  [C.TWENTY_COUNTRIES_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'countries', {
      ...state.countries,
      items: payload,
      itemsLoading: false,
    });
  },

  [C.TWENTY_COUNTRIES_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'countries', {
      ...state.countries,
      itemsLoading: false,
      itemsError: payload,
    });
  },
  // endregion

  // region Areas
  [C.TWENTY_AREAS_LOAD_PENDING](state) {
    Vue.set(state, 'areas', {
      ...state.areas,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
    });
  },

  [C.TWENTY_AREAS_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'areas', {
      ...state.areas,
      items: payload,
      itemsLoading: false,
    });
  },

  [C.TWENTY_AREAS_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'areas', {
      ...state.areas,
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.TWENTY_AREAS_CLEAR](state) {
    Vue.set(state, 'areas', {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
    });
  },
  // endregion
};



// WEBPACK FOOTER //
// ./src/store/modules/twenty/mutations.js